import { Block } from '@aloft/toolkit-sui';

export function Divider() {
  return (
    <Block width="100%" borderTopWidth="1px" borderStyle="solid" borderColor="strokeDefault" />
  );
}
